import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

export default function EmptyState({ message = "No confessions yet.", submessage = "Be the first to drop a confession." }) {
  const { theme } = useTheme();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center p-20 text-slate-400 dark:text-slate-600 bg-white dark:bg-black transition-colors"
    >
      <img 
        src={theme === 'dark' ? "/logo.png" : "/logo-light.png"} 
        alt="Empty State Ghost" 
        className="w-16 h-16 mb-5 opacity-40 grayscale"
      />
      <p className="text-[17px] font-bold text-slate-900 dark:text-white">{message}</p>
      <p className="text-sm mt-1 font-medium">{submessage}</p>
    </motion.div>
  );
}
